import { render, staticRenderFns } from "./LFlex.vue?vue&type=template&id=75641b8e&"
import script from "./LFlex.vue?vue&type=script&lang=js&"
export * from "./LFlex.vue?vue&type=script&lang=js&"
import style0 from "./LFlex.vue?vue&type=style&index=0&id=75641b8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports